import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const styles = {
    page: {
      backgroundColor: "#f8fafc",
      minHeight: "100vh",
      padding: "60px 20px",
      fontFamily: "'Inter', 'Segoe UI', Roboto, sans-serif",
      color: "#334155",
      lineHeight: "1.6",
    },
    container: {
      maxWidth: "850px",
      margin: "0 auto",
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      padding: "50px",
      boxShadow:
        "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
    },
    header: {
      borderBottom: "2px solid #e2e8f0",
      paddingBottom: "30px",
      marginBottom: "40px",
      textAlign: "center",
    },
    title: {
      fontSize: "36px",
      fontWeight: "800",
      color: "#097969",
      letterSpacing: "-0.025em",
      margin: "0 0 10px 0",
    },
    badge: {
      display: "inline-block",
      backgroundColor: "#dbeafe",
      color: "#097969",
      padding: "4px 12px",
      borderRadius: "9999px",
      fontSize: "12px",
      fontWeight: "600",
      textTransform: "uppercase",
    },
    section: {
      marginBottom: "35px",
    },
    sectionHeader: {
      display: "flex",
      alignItems: "center",
      marginBottom: "15px",
    },
    sectionNumber: {
      backgroundColor: "#097969",
      color: "white",
      width: "28px",
      height: "28px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "14px",
      fontWeight: "bold",
      marginRight: "12px",
      flexShrink: 0,
    },
    sectionTitle: {
      fontSize: "22px",
      fontWeight: "700",
      color: "#1e293b",
      margin: 0,
    },
    text: {
      fontSize: "16px",
      color: "#475569",
      marginLeft: "40px",
    },
    list: {
      marginLeft: "40px",
      paddingLeft: "20px",
      color: "#475569",
    },
    listItem: {
      marginBottom: "10px",
    },
    contactCard: {
      marginLeft: "40px",
      marginTop: "20px",
      padding: "25px",
      backgroundColor: "#f1f5f9",
      borderRadius: "12px",
      borderLeft: "5px solid #097969",
    },
    contactLink: {
      color: "#097969",
      textDecoration: "none",
      fontWeight: "500",
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        
        {/* Back Button */}
        <button
          className="btn btn-md d-flex align-items-center gap-2 fw-bold text-muted border-0 bg-transparent mb-3"
          onClick={() => navigate("/")}
        >
          <FaArrowLeft /> Back
        </button>

        <header style={styles.header}>
          <span style={styles.badge}>Compliance Document</span>
          <h1 style={styles.title}>Privacy Policy</h1>
          <p style={{ color: "#64748b", fontSize: "14px" }}>
            Effective Date: <strong>March 15, 2024</strong>
          </p>
        </header>

        <p
          style={{
            ...styles.text,
            marginLeft: 0,
            marginBottom: "30px",
            fontSize: "18px",
          }}
        >
          At <strong>Shreenath nx</strong>, we recognize that privacy is vital to
          our customers—students, parents, and schools alike. This policy
          outlines how we protect the information you entrust to us.
        </p>

        {/* Section 1 */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>1</div>
            <h2 style={styles.sectionTitle}>Information We Collect</h2>
          </div>
          <p style={styles.text}>
            To facilitate uniform sizing and delivery, we collect:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Personal Identifiers:</strong> Name, parent/guardian
              details, and student school affiliation.
            </li>
            <li style={styles.listItem}>
              <strong>Contact Data:</strong> Email address and phone number for
              order tracking.
            </li>
            <li style={styles.listItem}>
              <strong>Logistical Data:</strong> Shipping and billing addresses.
            </li>
            <li style={styles.listItem}>
              <strong>Payment Information:</strong> Processed via encrypted
              providers (we do not store full card numbers).
            </li>
          </ul>
        </div>

        {/* Section 2 */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>2</div>
            <h2 style={styles.sectionTitle}>How We Use Your Data</h2>
          </div>
          <div style={styles.text}>
            Your data is used strictly for fulfilling our service to you:
            <ul style={{ marginTop: "10px" }}>
              <li>Processing school-specific uniform orders.</li>
              <li>Verifying student eligibility for specific school emblems.</li>
              <li>Notifying you of back-to-school deadlines and order status.</li>
            </ul>
          </div>
        </div>

        {/* Section 3 */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>3</div>
            <h2 style={styles.sectionTitle}>Security Measures</h2>
          </div>
          <p style={styles.text}>
            We implement 256-bit SSL encryption for all transactions. Data
            access is restricted to authorized personnel managing your school’s
            account to ensure student privacy is maintained at all times.
          </p>
        </div>

        {/* Section 4 */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>4</div>
            <h2 style={styles.sectionTitle}>Your Rights</h2>
          </div>
          <p style={styles.text}>
            You have the right to request a copy of the data we hold, or ask for
            the deletion of your account once the school year cycle is complete.
          </p>
        </div>

        {/* Contact Section */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>5</div>
            <h2 style={styles.sectionTitle}>
              Contact Our Privacy Officer
            </h2>
          </div>
          <div style={styles.contactCard}>
            <p>
              <strong>Support Email:</strong>{" "}
              <a
                href="mailto:nxshreenath@gmail.com"
                style={styles.contactLink}
              >
                nxshreenath@gmail.com
              </a>
            </p>
            <p>
              <strong>Phone:</strong> +91 9712586101
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;